export default "__VITE_ASSET__8m_HnG9q__"